import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';
import { ClientDto } from 'src/app/api/invoice/models';
import { ClientService } from 'src/app/api/invoice/services';
import { IListParams } from '../../models/user.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-dropdown',
  templateUrl: './client-dropdown.component.html',
  styleUrls: ['./client-dropdown.component.scss'],
})
export class ClientDropdownComponent {
  // private selectedItem: ClientDto | undefined;
  clientOptions: ClientDto[] = [];
  isFieldFocused = false;
  private inputSubject = new Subject<string>();
  clientParams = { page: 0, size: 100, search: '' };
  searchTerm = '';
  @Output() clientSelectionChange = new EventEmitter<ClientDto>();
  @Input() selectedClient: ClientDto | null = null;

  // selectedClient: ClientDto = {};

  constructor(
    private clientService: ClientService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.fetchClients(this.clientParams);

    this.inputSubject
      //  debounce time as needed
      .pipe(debounceTime(1000))
      .subscribe(searchTerm => {
        this.clientParams.search = searchTerm;
        this.fetchClients(this.clientParams);
      });
  }

  onClientSelectionChange(selectedValue: ClientDto) {
    this.clientSelectionChange.emit(selectedValue);
  }
  clearSearchClients() {
    this.clientParams.search = '';
    this.fetchClients(this.clientParams);
  }
  onInput(event: Event): void {
    this.searchTerm = (event.target as HTMLInputElement).value;
    this.inputSubject.next(this.searchTerm);
  }

  Onclose() {
    this.searchTerm = '';
    this.inputSubject.next(this.searchTerm);
  }

  fetchClients(params: IListParams) {
    this.clientService.getAllClients(params).subscribe({
      next: response => {
        if (response?.data) {
          this.clientOptions = response.data[0]?.data || [];
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }
  customSearchFn(term: string, item: ClientDto) {
    return item;
  }
}
